import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The toolbar enables you to test your feature flags. You can enable, disable, or override your feature flags, and then view how your website or app changes with the new feature flags values.`}</p>
    <p>{`To do this, click on the "Feature Flags" button in the toolbar, search for any feature flag, and click on the toggles to change its value. `}</p>
    <p>{`Overriding feature flags will only affect `}<em parentName="p">{`your`}</em>{` browser. You may also need to refresh the page to see how your change affect your website. It does not affect feature flags evaluation for your backend.`}</p>
    <p><video parentName="p" {...{
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "src": "/static/toolbar-feature-flags-bca2fd69a43eca0694004ccce5e2fc25.mp4"
      }}></video>{` `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      